import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatTableModule} from '@angular/material/table';
import { HomeService } from '../home.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';


export interface PeriodicElement {
position:number,
 email: string,
 numberPhone: string,
 companyName: string,
 message: string
}

@Component({
  selector: 'app-data-hire',
  standalone: true,
  imports: [CommonModule, MatTableModule],
  templateUrl: './data-hire.component.html',
  styleUrls: ['./data-hire.component.scss']
})
export class DataHireComponent implements OnInit {
  isSucces = false;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = ['email', 'numberPhone', 'companyName', 'message', 'remove']


  constructor(private homeService: HomeService) { }

  ngOnInit(): void {
   this.getDataPesan();
  }

  getDataPesan(){
    this.homeService.getHireData().subscribe((value: any) => {
      this.dataSource.data = value.data
    })
  }

  delete(id: any){
    this.homeService.deleteHireData(id).subscribe((value:any) => {
      console.log(value)
      this.isSucces = true;
      setTimeout(() => {
        this.isSucces = false;
      }, 5000)
      this.getDataPesan();
    })
  }

}
